// Shared wildcard-to-regex conversion used by both UriLib's blacklist/whitelist
// helpers and QueryParamWhitelist. A single `*` in a whitelist/blacklist entry
// matches any run of characters. Kept in one place so the semantics cannot fork.
function wildcardToRegex(str) {
  const escapeRegex = (u) => u.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
  return new RegExp(`^${str.split('*').map(escapeRegex).join('.*')}$`);
}

module.exports = { wildcardToRegex };
